module.exports = __webpack_public_path__ + "static/media/AvenirNext-DemiBold.d49f3ba5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNext-DemiBold.ttf
// module id = 85
// module chunks = 0